export default `
  query productsList($search: String = "", $filter: ProductAttributeFilterInput, $pageSize: Int = 100, $currentPage: Int = 1, $sort: ProductAttributeSortInput) {
    products(search: $search, filter: $filter, pageSize: $pageSize, currentPage: $currentPage, sort: $sort) {
      items {
          ... on ConfigurableProduct {
          sku
          variants {
            product {
              sku
            }
          }
       }
      }
    }
  }
`;